import React from 'react';
import { MultiFormManagerProvider } from '@contexts/multi-form-manager-context';

const WithMultiFormManager = (WrappedComponent) => {
  const WithMultiFormManagerComponent = (props) => {
    return (
      <MultiFormManagerProvider>
        <WrappedComponent {...props} />
      </MultiFormManagerProvider>
    );
  };

  // Preservar el nombre del componente para debugging
  WithMultiFormManagerComponent.displayName = `WithMultiFormManager(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithMultiFormManagerComponent;
};

export default WithMultiFormManager; 